export default "__VITE_ASSET__7d98ff53__"